@if (jobDetails(); as jobDetails) {
  <div class="p-position" itemscope itemtype="http://schema.org/JobPosting">
    <section class="headline">
      <app-header></app-header>
      <div class="wrap">
        <h1 itemprop="title">{{jobDetails.name}}</h1>
        <span itemprop="jobLocation" itemscope itemtype="http://schema.org/Place">
          <app-flag [country]="jobDetails.location.country.toUpperCase()"></app-flag>
          <span itemprop="address" itemscope itemtype="http://schema.org/PostalAddress">
            {{jobDetails.location.fullLocation}}
          </span>
        </span>
      </div>
      <app-copyright></app-copyright>
    </section>
    <section class="wrap content">
      @if (jobDetails.jobAd.sections.companyDescription?.text) {
        <div>
          <h2>{{jobDetails.jobAd.sections.companyDescription!.title}}</h2>
          <div [innerHTML]="jobDetails.jobAd.sections.companyDescription!.text | decodeHtmlEntities"></div>
        </div>
      }
      @if (jobDetails.jobAd.sections.jobDescription?.text) {
        <div itemprop="description">
          <h2>{{jobDetails.jobAd.sections.jobDescription!.title}}</h2>
          <div [innerHTML]="jobDetails.jobAd.sections.jobDescription!.text | decodeHtmlEntities"></div>
        </div>
      }
      @if (jobDetails.jobAd.sections.qualifications?.text) {
        <div>
          <h2>{{jobDetails.jobAd.sections.qualifications!.title}}</h2>
          <div [innerHTML]="jobDetails.jobAd.sections.qualifications!.text | decodeHtmlEntities"></div>
        </div>
      }
      @if (jobDetails.jobAd.sections.additionalInformation?.text) {
        <div>
          <h2>{{jobDetails.jobAd.sections.additionalInformation!.title}}</h2>
          <div [innerHTML]="jobDetails.jobAd.sections.additionalInformation!.text | decodeHtmlEntities"></div>
        </div>
      }
      <div class="position-footer">
        <div class="align-center">
          <a [attr.href]="jobDetails.applyUrl" target="_blank" class="button" translate="jobDetails_applyBtn"></a>
        </div>
        <div class="align-center back-btn-wrapper">
          <a [routerLink]="['']" translate="jobDetails_backBtn"></a>
        </div>
      </div>
    </section>
    <app-map [location]="mapLocation()"></app-map>
  </div>
}
